export abstract class LoggerService {
  abstract trace(...messages: unknown[]): void;
  abstract debug(...messages: unknown[]): void;
  abstract log(...messages: unknown[]): void;
  abstract warn(...messages: unknown[]): void;
  abstract error(...messages: unknown[]): void;
}
